import React, { useCallback, useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'
import PubSub from 'pubsub-js'

import SelectCar from '../select-car'

export default function ProtalModal() {
  const [fixType, setFixType] = useState('')

  const [handleType, setHandleType] = useState(fixType)
  const handler = useCallback((type, value) => {
    if (fixType) {
      return
    }
    setHandleType(value)
  }, [])

  // TODO:
  const [show, setShow] = useState(false)
  const showHandler = useCallback((type, value) => {
    setShow(value)
  }, [])

  const fixHandler = useCallback((type, value) => {
    if (value) {
      setFixType('on')
      return
    }
    setFixType('')
  }, [])

  useEffect(() => {
    const token = PubSub.subscribe('SIDE_NAV_STATUS', handler)
    const showToken = PubSub.subscribe('HOVER_CAR_STATUS', showHandler)
    const fixToken = PubSub.subscribe('OPEN_FIX_NAV', fixHandler)
    return () => {
      PubSub.unsubscribe(token)
      PubSub.unsubscribe(showToken)
      PubSub.unsubscribe(fixToken)
    }
  }, [])

  const getHoverClassName: string = useMemo(() => {
    if (fixType) {
      return fixType
    }
    if (handleType) {
      return handleType
    }
    return ''
  }, [handleType, fixType, show])

  const getClassName: string = useMemo(() => {
    if (fixType) {
      return fixType
    }
    if (handleType) {
      return handleType
    }
    return 'tw-left-88 lg:tw-left-160'
  }, [handleType, fixType, show])

  return (
    <>
      <div className="car-modal-mask tw-hidden 2xl:tw-block">
        <style jsx>
          {`
            .car-modal-mask {
              width: calc((100% - 1920px) / 2);
              position: fixed;
              left: 0;
              height: 100%;
              top: 0;
              background: #e6e8f2;
              z-index: 999;
            }
          `}
        </style>
      </div>
      <div
        className={classNames(getClassName, {
          'side-hover-item': true,
          'tw-h-calc80 sm:tw-h-calc86': true,
          active: show,
        })}
      >
        <SelectCar />
        <style jsx>
          {`
            .side-hover-item {
              transform: translate3d(-110%, 0, 0);
            }
            .side-hover-item.active {
              transform: translate3d(0, 0, 0);
            }
            .side-hover-item:hover {
              transform: translate3d(0, 0, 0);
            }
            .side-hover-item {
              z-index: 9;
              position: absolute;
              border-top: 8px solid transparent;
              border-left: 8px solid transparent;
              top: 0;
              box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);
              transition: transform 0.2s ease-in-out;
            }

            .on.side-hover-item {
              left: 160px !important;
            }

            .off.side-hover-item {
              left: 88px !important;
            }
          `}
        </style>
      </div>
    </>
  )
}
